import { Injectable } from '@angular/core';
import { SsoAuthService } from '../../ecan/sso-auth.service';
import { UserService } from '../../shared/api/users/user.service';

@Injectable({
  providedIn: 'root'
})
export class EcNumberLinkingService {

  constructor(
    private ssoAuthService: SsoAuthService,
    private userService: UserService) {
  }

  public init() {
    this.ssoAuthService.registerEventCallback('authenticated', (profile) => { this.onAuthenticated(profile); });
  }

  private onAuthenticated(profile) {
    if (profile && !profile.ecLinked) {
        console.log('EcNumberLinkingService: Users profiles is not ec linked');
        this.userService.autoLinkEcNumber().subscribe(
          (ecNoLinkingResult) => {
            if (ecNoLinkingResult.ecNumber) {
                console.log('EcNumberLinkingService: Users profile succesfully linked to ec number ' + ecNoLinkingResult.ecNumber);
                // refresh the users token so it now has the ec number
                this.ssoAuthService.refreshToken(false);
            }
          },
          () => {
            console.warn('EcNumberLinkingService: Failed to link ec number to user profile');
          });
    } else {
        console.log('EcNumberLinkingService: Users profiles is already ec linked');
    }
  }
}
